module.exports = __webpack_public_path__ + "static/UnboxingDoodle-3cbecd79b5c7a1af18e60c2a331b792f.png";